module.exports = __webpack_public_path__ + "img/grad2.950d75da.jpg";